export default __webpack_public_path__ + "static/media/controlRecurring24.ef01c8b0.svg";